import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "react-query";
import { Put } from "../utils/api";
import { Order } from "../../types/api/Order";
import { useNavigate } from "react-router-dom";

export default (orgId: string, buyerOrgId: string, orderId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation<Order>(
    `submit-order`,
    async () => {
      return await Put<Order>(
        `/api/order/${orderId}/submit`,
        await getAccessTokenSilently()
      );
    },
    {
      onSuccess: () => {
        navigate(`/storefront/${orgId}/orders`);
        queryClient.invalidateQueries([`current_cart_${orgId}_${buyerOrgId}`]);
      },
    }
  );
};
